import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from '@shared/shared.module';
import {
    FormWidgetCountries
} from '@bcm-work-flows/@form-widgets/country-autocomplete/form-widget-countries.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { OrderModule } from 'ngx-order-pipe';

@NgModule({
    declarations: [FormWidgetCountries],
    imports: [
        FuseSharedModule,
        SharedModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        OrderModule,
    ],
    exports: [FormWidgetCountries]
})
export class FormWidgetCountriesModule {

}
